.clickable {
    color: inherit;
    border: 0;
    cursor: pointer;
    margin: 0;
    outline: 0;
    padding: 0;
    width: 100%;
    text-align: inherit;
    text-decoration: none;
    background-color: transparent;
    font-family: inherit;
    font-size: inherit;
    font-style: inherit;
    font-variant: inherit;
    font-weight: inherit;
    line-height: inherit;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:disabled {
        cursor: default;
        pointer-events: none;
    }
}

.column {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    overflow-x: hidden;
    overflow-y: hidden;

    > * {
        flex-grow: 0;
        flex-shrink: 0;
    }
}

.row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-y: hidden;
    overflow-x: hidden;
}

.justify-center {
    justify-content: center;
}

.justify-start {
    justify-content: flex-start;
}

.justify-end {
    justify-content: flex-end;
}

.justify-space-between {
    justify-content: space-between;
}

.justify-space-around {
    justify-content: space-around;
}

.align-center {
    align-items: center;
}

.align-start {
    align-items: flex-start;
}

.align-end {
    align-items: flex-end;
}

.wrap {
    flex-wrap: wrap;
}

.disable-hover {
    -webkit-appearance: none !important;
    -moz-appearance:    none !important;
    appearance:         none !important;

    &:hover {
        background: transparent;
        -webkit-appearance: none !important;
        -moz-appearance:    none !important;
        appearance:         none !important;
    }

}
